!function () {
  "use strict";

  customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        constructor() {
          super();
          this.debounceTimer = null;
          this.debounceDelay = 350;
        }

        connectedCallback() {
          this.input = this.querySelector("input");
          this.changeEvent = new Event("change", { bubbles: true });
          this.buttonClickEvent = this.onButtonClick.bind(this);
          this.onQuantityChangeEvent = this.onQuantityChange.bind(this);
          this.input.addEventListener("change", this.onQuantityChangeEvent);
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
        }

        onButtonClick(t) {
          t.preventDefault();
          const e = this.input.value;
          const n =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
          "increase" === n.name && this.input.stepUp();
          "decrease" === n.name && this.input.stepDown();
          if (e !== this.input.value) {
            this.lastChangeFromButton = true;
            this.input.dispatchEvent(this.changeEvent);
          }
        }

        onQuantityChange() {
          if ("updates[]" != this.input.name) return;
          if (this.lastChangeFromButton) {
            this.lastChangeFromButton = false;
            clearTimeout(this.debounceTimer);
            this.updateCart();
          } else {
            this.debouncedUpdateCart();
          }
        }

        debouncedUpdateCart() {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
            this.updateCart();
          }, this.debounceDelay);
        }

        updateCart() {
          "" !== this.quantityValue &&
            this.dispatchEvent(
              new CustomEvent("theme:cart:update", {
                bubbles: true,
                detail: {
                  id: this.input.dataset.id,
                  quantity: this.input.value,
                },
              })
            );
        }

        disconnectedCallback() {
          clearTimeout(this.debounceTimer);
        }
      }
    );
}();
